<div mat-dialog-title *ngIf="options.title">
  {{ options.title }}
</div>
<mat-dialog-content>
  <p>{{ options.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="options.actionsVisible !== false">
  <button type="button" mat-flat-button [mat-dialog-close]="false" color="accent" cdkFocusInitial>
    {{ options.cancelButtonLabel | empty: 'Cancel' }}
  </button>
  <button type="button" mat-flat-button color="primary" [mat-dialog-close]="true">
    {{ options.confirmButtonLabel | empty: 'OK' }}
  </button>
</mat-dialog-actions>
